import { ITCFGlobalVendorList } from "types/tcf";
import {
  ITCFLegIntCategoryName,
  ITCFVendorCategory,
} from "../TCFConsentProvider/types";
import { AppStateContext } from "core/AppStateContext";

// Check if any vendor require this purpose, to not display purposes that are not used to not confuse the end users
const isTCFCategoryPresent = (
  purposesName: ITCFVendorCategory | ITCFLegIntCategoryName,
  purposeId: number,
  gvl: ITCFGlobalVendorList,
  selectedVendorsList: AppStateContext["tcfVendorsList"]
) => {
  if (gvl) {
    return selectedVendorsList.some((vendorId) =>
      gvl.vendors[vendorId][purposesName].includes(purposeId)
    );
  }

  return false;
};

export default isTCFCategoryPresent;
